/** Exact workflow patterns attached to an allowed menu, never a module prefix. */
export const PROFILE_WORKFLOW_ROUTES: Record<string, string[]> = {
  '/contacts': ['/contacts/:id'],
  '/leads': ['/leads/:id', '/deals', '/deals/:id'],
  '/leads/triage': ['/leads/dashboard'],
  // 2026-10-04: the drawer's "Open the statement" — the server reads a manager's own dealers' ledger.
  '/dealer-management': ['/dealer-leads', '/dealer-ledger', '/dealer-ledger/:dealerId'],
  '/proposals': ['/proposals/new', '/proposals/:id/edit', '/estimates', '/estimates/new', '/estimates/:id/edit'],
  '/quick-quote': [
    '/sales/meeting/start', '/sales/meeting/calculators', '/sales/meeting/calculator',
    '/sales/meeting/calculator/pool', '/sales/meeting/calculator/commercial-heat-pump',
    '/sales/meeting/calculator/ss-tank', '/sales/meeting/calculator/customized-tank',
    '/sales/meeting/calculator/domestic-heat-pump',
  ],
  '/sales-orders': ['/sales-orders/new', '/sales-orders/:id', '/sales-orders/:id/edit'],
  '/telecaller': ['/telecaller/call/:callId'],
  '/invoices': ['/invoices/new', '/invoices/:id', '/invoices/:id/edit'],
  '/purchase-invoices': ['/purchase-invoices/new', '/purchase-invoices/:id'],
  '/ledger/vouchers': ['/ledger/vouchers/:id'],
  '/accounting?tab=ledger': ['/ledger/accounts/:accountId'],
  '/finance/approvals': ['/sales-orders/:soId/financial-approval', '/warehouse/gate-entries'],
  // Sugandha (P04) reads the gate exception report; her only operations entry is this view.
  '/dispatch-status': ['/warehouse/gate-entries'],
  '/purchase-requests': ['/purchase-requests/:id'],
  '/purchase-orders': ['/purchase-orders/new', '/purchase-orders/:id/edit', '/warehouse/gate-entries'],
  '/quotation-jobs': ['/quotation-jobs/:id'],
  '/production': ['/manufacturing/orders/new', '/production-orders/:id', '/manufacturing/orders/:id', '/manufacturing/production-orders/:id'],
  '/manufacturing/dashboard': ['/manufacturing/shop-floor'],
  '/manufacturing/boms': ['/boms/new', '/boms/:id/edit'],
  // 2026-10-04 Gate Entry (material IN). Reached from the guard dashboard, the inward
  // screen and the held-GRN alert link — the locked profile menus are unchanged.
  '/gate': ['/gate/entry'],
  '/warehouse/inward': ['/warehouse/grn', '/warehouse/gate-entries'],
  '/warehouse/dashboard': ['/warehouse'],
  '/inventory': ['/warehouse/inventory'],
  '/dispatch-forms': ['/dispatch-forms/:id', '/dispatch-forms/new/:salesOrderId', '/dispatch-config/from-so/:salesOrderId', '/dispatch-config/slip/:id'],
  '/dispatch/shipments': ['/shipments', '/shipments/:id', '/dispatch/shipments/:id'],
  '/service-tickets': ['/service-tickets/new', '/service-tickets/:id', '/service-tickets/:id/components', '/service-tickets/:id/photos', '/service-tickets/:id/audit', '/service-tickets/:id/otp', '/service', '/service/tickets', '/tickets'],
  '/service/my-tickets': ['/service-tickets/:id', '/service-tickets/:id/components', '/service-tickets/:id/photos', '/service-tickets/:id/otp', '/service/pre-visit/:id', '/service/diagnosis/:id', '/service/on-site/:id', '/service/warranty-claim/:id'],
  '/service/installations': ['/service/installations/:id', '/service/itbp-installations', '/service/itbp-installations/:id'],
  '/warranty-lookup': ['/service/warranty-verify/:id', '/inventory/units/:code/history'],
  '/admin/roles': ['/admin/permissions'],
  // 2026-10-02 App Tour — one lesson page per lesson id (M08-L20).
  '/tour': ['/tour/:lessonId'],
};

// SUN-48 N5 (Manak): lead triage (P03) shares the "Dealers" row (/dealer-management) with the sales
// profiles, whose workflow routes include the dealer ledger. Triage never reads dealer money.
export const PROFILE_DENIED_WORKFLOW_ROUTES: Record<string, string[]> = {
  P03: ['/dealer-ledger', '/dealer-ledger/:dealerId'],
};

// SUN-42 D16: /admin/audit-logs is all companies' log — platform only, as the server's profile gate and superAdminOnly say.
export const PLATFORM_ROUTES = ['/admin', '/admin/tenants', '/admin/billing', '/admin/health', '/admin/resources', '/admin/audit-logs'];

export function routePatternMatches(pattern: string, pathname: string): boolean {
  const expected = pattern.split('/');
  const actual = pathname.split('/');
  return expected.length === actual.length && expected.every((part, i) =>
    part.startsWith(':') ? /^[\w-]+$/.test(actual[i]) : part === actual[i]);
}
